import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useSiteMessageBarStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    ...shorthands.padding("6px", "18px", "0px", "18px"),
  },
  messageBarWrapper: {
    overflow: "hidden",
    position: "relative",
    "::after": {
      position: "absolute",
    },
    "@media (min-width: 500px) and (max-width: 899px)": {
      marginLeft: "40px",
      marginRight: "40px",
      maxWidth: "100%",
      ...shorthands.padding("6px", "0px", "0px", "0px"),
    },
    "@media (min-width: 900px) and (max-width: 1239px)": {
      ...shorthands.margin("0px", "auto"),
      width: "840px",
      ...shorthands.padding("6px", "0px", "0px", "0px"),
    },
    "@media (min-width: 1240px) and (max-width: 1399px)": {
      marginLeft: "200px",
      marginRight: "200px",
      maxWidth: "100%",
      ...shorthands.padding("6px", "0px", "0px", "0px"),
    },
    "@media (min-width: 1400px)": {
      ...shorthands.margin("0px", "auto"),
      width: "1040px",
      ...shorthands.padding("6px", "0px", "0px", "0px"),
    },
    "& a": {
      color: tokens.colorBrandForegroundLink,
      textDecoration: "underline",
      "&:hover": {
        color: tokens.colorBrandForegroundLinkHover,
      },
      "&:focus-visible": {
        ...shorthands.outline("2px", "solid", tokens.colorStrokeFocus2),
        outlineOffset: "2px",
        ...shorthands.borderRadius("2px"),
      },
    },
    "& .fui-MessageBar": {
      width: "100%",
    },
    "& .fui-MessageBarBody": {
      whiteSpace: "normal",
      wordBreak: "break-word",
      marginLeft: "8px",
      display: "block",
    },
    "& ul": {
      ...shorthands.margin("4px", "0px"),
      ...shorthands.padding("0px", "0px", "0px", "16px"),
      listStyleType: "disc",
      display: "block",
    },
    "& li": {
      display: "list-item",
      ...shorthands.padding("2px", "0px"),
    },
    "&& p": {
      display: "block", // wmde sets p { display:flex }
      width: "100%",
      breakInside: "avoid",
      WebkitColumnBreakInside: "avoid",
      MozColumnBreakInside: "avoid",
    },
    "&& strong": {
      display: "inline",
      fontWeight: 700,
    },
    "&& b": {
      display: "inline",
      fontWeight: 700,
    },
    "&& em": {
      display: "inline",
      fontStyle: "italic",
    },
    "&& i": {
      display: "inline",
      fontStyle: "italic",
    },
    "&& a": {
      display: "inline",
      color: "#0078d4",
      wordBreak: "break-word",
    },
  },
});
